export const environment = {
  production: true,
  urlApi: "https://dev-api.valesaudesempre.com.br/api",
  iuguAccountId: "3B43109C22F647F5A4F8D5E3CF1F5946",
  iuguTestMode: true,
  version: "1.11.0",
  SALT: ",s)S.X-p;SdwsA2&lR.dIy|SCg}bZ1{&7y^%kpk2u9V+{mEO%n3HccBYJIKhFujb",
  BUGSNAG_KEY: "664566da0ca6d2835a47ca8f0adfe08b",
};
